import { defineMessages } from 'react-intl';

export default defineMessages({
  selectQuantity: {
    id: 'Pdp.ProductVariantSelection.selectQuantity',
    defaultMessage: 'Select Quantity:',
  },
  firstProductAttributesUpperTitle: {
    id: 'Pdp.ProductVariantSelection.firstProductAttributesUpperTitle',
    description: 'Upper Title for First Product',
    defaultMessage: 'First {productName}',
  },
  secondProductAttributesUpperTitle: {
    id: 'Pdp.ProductVariantSelection.secondProductAttributesUpperTitle',
    description: 'Upper Title for Second Product',
    defaultMessage: 'Second {productName}',
  },
});
